// The web origin every shared link, OG tag and calendar URL is minted on (#325).
// Changing it needs a native release that claims the new host to be live first:
// OTA reaches old shells at once, and they open unclaimed links in the browser.
export const APP_ORIGIN = 'https://faro.dance'

// Every host that serves the app. The legacy hosts stay served and natively
// claimed forever (links shared before #325 point there) — never redirect them.
export const PUBLIC_ORIGINS = [
  'https://faro.dance',
  'https://beacon-festival-app.web.app',
  'https://beacon-festival-app.firebaseapp.com',
]
